import { render, staticRenderFns } from "./ArtSpecialtyScore.vue?vue&type=template&id=22b8ae41&scoped=true"
import script from "./ArtSpecialtyScore.vue?vue&type=script&lang=js"
export * from "./ArtSpecialtyScore.vue?vue&type=script&lang=js"
import style0 from "./ArtSpecialtyScore.vue?vue&type=style&index=0&id=22b8ae41&prod&lang=less"
import style1 from "./ArtSpecialtyScore.vue?vue&type=style&index=1&id=22b8ae41&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b8ae41",
  null
  
)

export default component.exports